import $http from '@/config/request';

//查询用户积分

export const getAccountApi = userNo => {
  return $http.get(`/user/userInfo/getAccount?userNo=${ userNo }`);
};

//获取用户G分收支明细
export const getGfenDetilApi = params => {
  return $http.get(`/user/userInfo/getGfenDetil?userNo=${ params.userNo }&time=${params.time}&flag=${params.flag}&pageNum=${params.pageNum}&pageSize=${params.pageSize}`);
};

